mutation deleteSavedContentForNewsletter($input: DeleteSavedContentInput!) {
  deleteSavedContentForNewsletter(input: $input)
}
